const Accordion = require('vanilla-js-accordion');

const collapse = (widget = null) => {

  let AccordionElements;

  if (widget) {
    AccordionElements = document.querySelectorAll(`${widget} .u-accordion`)
  } else {
    AccordionElements = document.querySelectorAll('.u-accordion')
  }

  if (AccordionElements) {
    AccordionElements.forEach(AccordionElement => {

      const options = {
        item: '.c-accordion__item',
        target: '.c-accordion__target',
        control: '.c-accordion__control',
        panel: '.c-accordion__panel',
        allowMultiple: false,
        transition: 'height .3s cubic-bezier(0.7, 0.6, 0.1, 0.8)',
      }

      new Accordion(AccordionElement, options);

    });
  }
}

collapse();
window.collapse = collapse
